"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labelStyling = exports.hoverEffect = exports.displayFullWidth = exports.heightValues = void 0;
var heightValues = {
  maxHeight: '48px',
  'min-height': '48px',
  lineHeight: '26px'
};
exports.heightValues = heightValues;
var displayFullWidth = {
  '& button': {
    display: 'inline-block',
    'vertical-align': 'top'
  },
  '&.tabs_children_1 button': {
    width: '100%'
  },
  '&.tabs_children_2 button': {
    width: '50%'
  },
  '&.tabs_children_3 button': {
    width: 'calc(100% / 3)'
  },
  '&.tabs_children_4 button': {
    width: '25%'
  },
  '&.tabs_children_5 button': {
    width: '20%'
  },
  '&.tabs_children_6 button': {
    width: 'calc(100% / 6)'
  },
  padding: '0'
};
exports.displayFullWidth = displayFullWidth;
var hoverEffect = {
  '& button:hover': {
    background: 'rgba(0,0,0,0.05)'
  }
};
exports.hoverEffect = hoverEffect;
var labelStyling = {
  '& > span > span': {
    padding: '6px 8px !important',
    fontSize: '14px !important',
    fontWeight: '400 !important'
  }
};
exports.labelStyling = labelStyling;